<template>
  <div class="p-0">
    <div
      class="overflow-hidden relative org-card mb-4 bg-white grid lg:grid-cols-2 grid-cols-1 lg:grid-flow-col grid-flow-row shadow-sm px-8 py-6 gap-16 rounded-xl items-center"
    >
      <div class="wallet col-span-1">
        <div class="user flex flex-col md:flex-row w-full">
          <div
            class="user__picture flex mb-5 md:mb-0 justify-center items-center md:items-start relative"
          >
            <img
              v-if="userData.profilePictureUrl"
              class="__img"
              :src="
                constants.s3Bucket +
                '/editor/profile-pictures/' +
                userData.profilePictureUrl
              "
            />
            <img
              v-else
              class="__img"
              :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                userData.firstName || 'boringAvatar',
                userData.lastName || 'boringAvatar'
              )}`"
            />
            <span class="__level font-black uppercase">level {{ level }}</span>
          </div>
          <div
            class="user__info w-full text-left flex flex-col justify-between ml-0 md:ml-6"
          >
            <div class="text-center md:text-left">
              <h3 class="user__info--name mb-1 text-2xl">
                {{ userData.firstName }} {{ userData.lastName }}
              </h3>
              <p class="user__info--title font-light">
                {{ userData.profession }}
              </p>
            </div>
            <div class="pt-3 relative">
              <div>
                <progress
                  class="progress w-full"
                  :value="this.progressPercent"
                  max="100"
                ></progress>
                <img
                  class="w-10 h-10 xp absolute"
                  src="@/assets/images/icons/tokens/xp.svg"
                  alt="xp"
                />
              </div>
              <div class="flex justify-between mt-1">
                <span class="text-xs text-black font-medium"
                  >{{ progressPercent }}% {{ $t('orgDashboard.userDashboard.wallet.done') }}</span
                >
                <span class="text-xs text-black font-medium mr-8"
                  >XPs {{ requiredXP }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="balance w-full flex flex-row flex-wrap mt-2 md:mt-4 justify-between md:justify-start"
        >
          <div
            class="balance__item flex items-center overflow-hidden p-0 mt-2 md:mt-4 mr-2 md:mr-6"
          >
            <img
              class="balance__item__img p-1 md:p-2 w-16 h-16"
              src="@/assets/images/icons/tokens/xp.svg"
              alt="xp"
            />
            <h5
              class="balance__item__title px-0 py-1 md:py-3 font-medium text-center"
            >
              {{ xp }} XPs
            </h5>
          </div>

          <div class="flex" v-for="(tokens, index) in userTokens" :key="index">
            <div
              class="flex mr-2"
              v-if="
                tokens.label !== 'XP' &&
                tokens.label !== 'Knowledge' &&
                tokens.label !== 'Key'
              "
            >
              <div
                class="balance__item flex items-center overflow-hidden p-0 mt-2 md:mt-4 relative mr-2 md:mr-6"
                v-for="(val, index) in tokens.tokens"
                :key="index"
              >
                <img
                  v-if="tokens.label === 'Gold'"
                  class="balance__item__img p-1 md:p-2 w-16 h-16"
                  src="@/assets/images/icons/tokens/gold-coin.svg"
                  alt="gold"
                />

                <div
                  v-if="tokens.label === 'Gold'"
                  class="org-logo absolute z-10 rounded-full overflow-hidden"
                  :style="{
                    bottom: '9px',
                    left: '23px',
                    width: '25px',
                    height: '25px',
                  }"
                >
                  <img
                    class="absolute object-contain border-0 p-0 w-full h-full left-0"
                    :src="`${constants.s3Bucket}/organization/logo/${val.organizationData.logo}`"
                    @error="randomFeedImage"
                    :alt="val.organizationData.name"
                  />
                </div>

                <img
                  v-if="tokens.label === 'Digital Tokens'"
                  class="balance__item__img p-1 md:p-2 w-16 h-16"
                  src="@/assets/images/icons/tokens/digital-token.svg"
                  alt="gold"
                />

                <div
                  v-if="tokens.label === 'Digital Tokens'"
                  class="org-logo absolute z-10 rounded-full overflow-hidden"
                  :style="{
                    bottom: '17px',
                    left: '15px',
                    width: '25px',
                    height: '25px',
                  }"
                >
                  <img
                    class="absolute object-contain border-0 p-0 w-full h-full left-0"
                    :src="`${constants.s3Bucket}/organization/logo/${val.organizationData.logo}`"
                    @error="randomFeedImage"
                    :alt="val.organizationData.name"
                  />
                </div>
                <h5
                  class="balance__item__title px-0 py-1 md:py-3 font-medium text-center"
                >
                  {{ val.tokenValueSum }} {{ tokens.label }}
                </h5>
              </div>
            </div>
          </div>

          <!-- <div
            class="balance__item flex items-center overflow-hidden p-0 mt-2 md:mt-4"
          >
            <img
              class="balance__item__img p-1 md:p-2 w-10 md:w-12 h-10 md:h-12"
              src="@/assets/images/icons/tokens/key.svg"
              alt="key"
            />
            <h6
              class="balance__item__title px-0 py-1 md:py-3 font-medium text-center"
            >
              {{ key }} Key
            </h6>
          </div> -->
        </div>
      </div>
      <div class="flex h-full w-full justify-end">
        <div
          class="cursor-pointer border-solid border-2 rounded-lg border-grey-200 px-3 h-fit flex items-center gap-2"
          @click="connectWalletPopup = !connectWalletPopup"
        >
          <img
            src="@/assets/images/icons/wallet-icon.svg"
            class="py-2"
            alt="Wallet"
          />
          <div
            class="text-black font-xl border-solid border-l-2 border-r-0 border-t-0 border-b-0 border-grey-200 py-2 pl-1"
          >
            {{ $t('orgDashboard.userDashboard.wallet.connectWallet') }}
          </div>
        </div>
        <!-- <wallet-card class="col-span-1 h-full w-full" /> -->
      </div>
    </div>
    <vx-card>
      <div class="flex justify-between p-4">
        <h3 class="text-lg font-medium">{{ $t('orgDashboard.userDashboard.wallet.walletHistory') }}</h3>
        <span class="cursor-pointer">
          <img
            class="bg-white"
            src="@/assets/images/icons/dropdown.svg"
            alt=""
          />
        </span>
      </div>
      <vs-table max-items="5" pagination :data="transactions">
        <template slot="thead">
          <vs-th class="table-header"> {{ $t('orgDashboard.userDashboard.wallet.status') }} </vs-th>
          <vs-th class="table-header"> {{ $t('orgDashboard.userDashboard.wallet.date') }} </vs-th>
          <vs-th class="table-header"> {{ $t('orgDashboard.userDashboard.wallet.amount') }} </vs-th>
          <vs-th class="table-header"> {{ $t('orgDashboard.userDashboard.wallet.transactions') }} </vs-th>
          <vs-th class="table-header"> {{ $t('orgDashboard.userDashboard.wallet.type') }} </vs-th>
          <vs-th class="table-header"> {{ $t('orgDashboard.userDashboard.wallet.details') }} </vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td
              v-if="data[indextr].source === 'market'"
              :data="data[indextr].status"
            >
              <div class="flex items-center justify-start">
                <vs-tooltip
                  text="Order Received"
                  v-if="data[indextr].fulfilled && data[indextr].received"
                >
                  <span class="txn-success"></span>
                </vs-tooltip>
                <vs-tooltip
                  text="Order Rejected"
                  v-else-if="data[indextr].rejected"
                >
                  <span class="txn-failed"></span>
                </vs-tooltip>
                <vs-tooltip text="Order Not Received" v-else>
                  <span class="txn-not-confirmed"></span>
                </vs-tooltip>
              </div>
            </vs-td>
            <vs-td v-else> </vs-td>
            <vs-td
              v-if="
                data[indextr].createdAt && data[indextr].source === 'MARKET'
              "
            >
              {{ data[indextr].createdAt.split("T")[0] }}
            </vs-td>
            <vs-td
              v-if="
                data[indextr].source === 'MARKET' && data[indextr]._metaData
              "
            >
              <span v-if="!isNaN(parseFloat(data[indextr].tokenKey))">
                {{
                  orgPriceTypes.filter(
                    (price) =>
                      price.key.toString() === data[indextr].tokenKey.toString()
                  )[0].label
                }}
              </span>
              <span v-else> € </span>
              <span>{{
                Math.abs(data[indextr].tokenValue) *
                (data[indextr]._metaData.qty || 1)
              }}</span>
            </vs-td>
            <vs-td v-else>€ 0 </vs-td>
            <vs-td v-if="data[indextr].fundType">
              <div
                class="items-center flex"
                v-if="data[indextr].source == 'market'"
              >
                <vs-tooltip
                  :text="
                    'Approved & Assigned by ' +
                    data[indextr].fulfilledBy.firstName
                  "
                  v-if="
                    data[indextr].fulfilled === true &&
                    data[indextr].fulfilledBy &&
                    Object.keys(data[indextr].fulfilledBy).length > 0
                  "
                >
                  <vs-button flat class="bg-white shadow-none m-0 p-0">
                    <vs-avatar
                      v-if="
                        data[indextr].fulfilled === true &&
                        data[indextr].fulfilledBy &&
                        Object.keys(data[indextr].fulfilledBy).length > 0 &&
                        data[indextr].fulfilledBy.profilePictureUrl
                      "
                      class="profile-picture"
                      size="32px"
                      :src="
                        constants.s3Bucket +
                        '/editor/profile-pictures/' +
                        data[indextr].fulfilledBy.profilePictureUrl
                      "
                    />
                    <vs-avatar
                      v-else
                      class="profile-picture"
                      size="32px"
                      :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                        data[indextr].fulfilledBy.firstName || 'boringAvatar',
                        data[indextr].fulfilledBy.lastName || 'boringAvatar'
                      )}`"
                    />
                  </vs-button>
                </vs-tooltip>
                <span
                  v-if="
                    data[indextr].fulfilled === true &&
                    data[indextr].fulfilledBy &&
                    Object.keys(data[indextr].fulfilledBy).length > 0
                  "
                  style="color: #6172f3"
                >
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </span>
                <!-- Product 4 cases -->
                <div
                  v-if="
                    data[indextr].fulfilled === true &&
                    data[indextr].fulfilledBy &&
                    Object.keys(data[indextr].fulfilledBy).length > 0
                  "
                >
                  <div
                    v-if="
                      data[indextr].product_details &&
                      data[indextr].fulfilled === true &&
                      data[indextr].fulfilledBy &&
                      Object.keys(data[indextr].fulfilledBy).length > 0
                    "
                    class="relative"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      class="absolute left-1/2 transform -translate-x-1/2 -translate-y-10"
                      v-if="hovered == data[indextr]"
                      @mouseover="showHoveredSVG(data[indextr])"
                      @mouseout="hideHoveredSVG"
                    >
                      <circle cx="16" cy="16" r="16" fill="#F2C244" />
                    </svg>
                    <vs-avatar
                      @mouseover="showHoveredSVG(data[indextr])"
                      @mouseout="hideHoveredSVG"
                      v-if="
                        data[indextr].product_details &&
                        data[indextr].fulfilled === true &&
                        data[indextr].fulfilledBy &&
                        Object.keys(data[indextr].fulfilledBy).length > 0 &&
                        hovered == data[indextr]
                      "
                      class="profile-picture transform-avatar absolute"
                      size="22px"
                      :src="
                        data[indextr].product_details.product_images[0] ||
                        constants.s3Bucket +
                          '/organization/logo/' +
                          orgData.logo
                      "
                    />
                    <img
                      src="@/assets/Iconography/market/MarketTransactionIcon.svg"
                      alt="Market Icon"
                      @mouseover="showHoveredSVG(data[indextr])"
                      @mouseout="hideHoveredSVG"
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="8"
                      viewBox="0 0 10 8"
                      fill="none"
                      class="absolute left-1/2 transform -translate-x-1/2 -translate-y-12 z-8 -mt-5 -mr-3"
                      v-if="hovered == data[indextr]"
                      @mouseover="showHoveredSVG(data[indextr])"
                      @mouseout="hideHoveredSVG"
                    >
                      <path
                        d="M4.13397 7.5C4.51887 8.16667 5.48113 8.16667 5.86603 7.5L9.33013 1.5C9.71503 0.833334 9.2339 0 8.4641 0H1.5359C0.766098 0 0.284973 0.833333 0.669873 1.5L4.13397 7.5Z"
                        fill="#F2C244"
                      />
                    </svg>
                  </div>

                  <vs-avatar
                    v-else
                    class="my-4 profile-picture -mt-4"
                    size="24px"
                    :src="
                      require('@/assets/images/icons/organization/business_black_36dp.svg')
                    "
                  />
                </div>
                <div v-else>
                  <vs-avatar
                    v-if="
                      data[indextr].product_details &&
                      data[indextr].product_details.product_images &&
                      data[indextr].product_details.product_images[0]
                    "
                    class="my-4 profile-picture"
                    size="32px"
                    :src="data[indextr].product_details.product_images[0]"
                  />
                  <vs-avatar
                    v-else-if="orgData.logo"
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      constants.s3Bucket + '/organization/logo/' + orgData.logo
                    "
                  />
                  <vs-avatar
                    v-else
                    class="my-4 profile-picture"
                    size="32px"
                    :src="
                      require('@/assets/images/icons/organization/business_black_36dp.svg')
                    "
                  />
                </div>

                <div
                  v-if="
                    data[indextr].fulfilled === true &&
                    data[indextr].fulfilledBy &&
                    Object.keys(data[indextr].fulfilledBy).length > 0
                  "
                  style="color: #6172f3"
                >
                  -
                  <span v-if="$root.$el.clientWidth > 700">-</span>
                </div>
                <div v-else style="color: #6172f3">- - - - - - -</div>

                <vs-tooltip
                  :text="'Ordered by ' + data[indextr].linkedUserData.firstName"
                  v-if="data[indextr].linkedUserData"
                >
                  <vs-button flat class="bg-white shadow-none m-0 p-0">
                    <vs-avatar
                      v-if="
                        data[indextr].linkedUserData &&
                        data[indextr].linkedUserData.profilePictureUrl
                      "
                      class="profile-picture"
                      size="32px"
                      :src="
                        constants.s3Bucket +
                        '/editor/profile-pictures/' +
                        data[indextr].linkedUserData.profilePictureUrl
                      "
                    />
                    <vs-avatar
                      v-else
                      class="profile-picture"
                      size="32px"
                      :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                        data[indextr].linkedUserData.firstName ||
                          'boringAvatar',
                        data[indextr].linkedUserData.lastName || 'boringAvatar'
                      )}`"
                    />
                  </vs-button>
                </vs-tooltip>
              </div>
            </vs-td>
            <vs-td v-else> </vs-td>
            <vs-td v-if="data[indextr].fundType">
              <span
                v-if="data[indextr].source == 'market'"
                class="txn-type-market txn-type flex gap-2 items-center max-w-fit"
              >
                <span class="txn-tip-market txn-tip"></span>
                {{ data[indextr].transactionType }}
              </span>
              <span
                v-else
                class="txn-type-core txn-type flex gap-2 items-center max-w-fit"
              >
                <span class="txn-tip-core txn-tip"></span>
                {{ data[indextr].fundType }}
              </span>
            </vs-td>
            <vs-td v-else> </vs-td>
            <vs-td
              v-if="data[indextr].details || data[indextr].product_details"
            >
              <load-details
                accessLevel="user"
                :transactionDetails="data[indextr]"
                :fetchTransactions="fetchUserTransactions"
              />
            </vs-td>
            <vs-td v-else> </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vs-popup title="Connect Wallet" :active.sync="connectWalletPopup">
      <div class="flex items-center justify-center">
        <div
          class="cursor-pointer border-solid border-2 rounded-lg border-grey-300 p-3 px-4 h-fit flex items-center gap-3 w-fit"
          @click="connectMetaMask"
        >
          <img src="@/assets/images/icons/metamask.svg" alt="Wallet" />
          <div class="text-black text-xl">Metamask Wallet</div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import constants from "@/constants";
import LoadDetails from "../../org-dashboard/treasury/LoadDetails.vue";
import rewardsAndTokenConfig from "@/assets/data/rewardsAndTokenConfig.js";
import xpLevel from "@/assets/data/xpLevel.js";
import WalletCard from "@/views/user-dashboard/components/WalletCard.vue";
import { connectMetaMaskWallet } from "./web3";

export default {
  data() {
    return {
      constants,
      userId: "",
      orgId: "",
      accessToken: "",
      transactions: [],
      hovered: false,
      xp: 0,
      gold: 0,
      key: 0,
      level: 0,
      progressPercent: 0,
      requiredXP: 0,
      connectWalletPopup: false,
    };
  },
  components: {
    LoadDetails,
    WalletCard,
  },
  computed: {
    userTokens() {
      return this.$store.state.users.userTokens;
    },
    userData() {
      return this.$store.state.users.data;
    },
    authUserData() {
      return this.$store.state.auth.user;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
    orgPriceTypes() {
      return this.$store.state.market.orgPriceTypes;
    },
  },
  watch: {
    userTokens: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getUserXP(newVal);
        }
      },
    },
    connectWalletPopup(newVal) {
      if (!newVal) {
        const urlWithoutHash = window.location.href.replace(/#.*$/, "");
        window.history.replaceState(null, null, urlWithoutHash);
      }
    },
  },
  mounted() {
    this.fetchUserTransactions();
    this.fetchOrgProductAndPriceTypes();
    this.fetchUserTokens(this.authUserData._id);
    if (this.$route.hash === "#connectwallet") {
      this.connectWalletPopup = true;
    }
  },
  methods: {
    fetchUserTransactions() {
      //this.$vs.loading();
      this.userId = JSON.parse(localStorage.getItem("user"))._id;
      if (this.userId !== undefined) {
        this.$store
          .dispatch("payments/fetchUserTransactions", {
            userId: this.userId,
          })
          .then((transactions) => {
            const marketTransaction = transactions.filter(
              (transaction) => transaction._metaData
            );
            // console.log(marketTransaction);
            this.transactions = marketTransaction;
            this.$forceUpdate();
            // this.$vs.loading.close();
          });
      }
    },
    fetchOrgProductAndPriceTypes() {
      const _accessToken = localStorage.getItem("accessToken");
      this.orgId = "6512fc951aa789001abd5ed4";
      const payload = { orgId: this.orgId, accessToken: _accessToken };

      if (
        _accessToken &&
        _accessToken !== "" &&
        _accessToken !== null &&
        _accessToken !== undefined &&
        this.orgId !== undefined
      ) {
        this.$store
          .dispatch("organization/fetchOrgProductAndPriceTypes", payload)
          .then((res) => {
            this.$store.commit("market/ORG_PRICE_TYPES", res[0]);
            this.$store.commit("market/ORG_PRODUCT_TYPES", res[1]);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    showHoveredSVG(data) {
      this.hovered = data;
    },
    hideHoveredSVG() {
      this.hovered = null;
    },
    getUserXP(tokens) {
      if (tokens && tokens.length > 0 && this.xp === 0) {
        let xp = tokens.find((token) => token.label === "XP");
        if (xp.tokens) {
          xp.tokens.forEach((obj) => {
            this.xp += obj.tokenValueSum;
          });
        }

        for (let i = 0; i < xpLevel.length; i++) {
          if (this.xp >= xpLevel[i].minXP && this.xp <= xpLevel[i].maxXP) {
            this.level = xpLevel[i].level;
            this.requiredXP = xpLevel[i].maxXP - xpLevel[i].minXP + 1;
            let earnedXP = this.xp - xpLevel[i].minXP + 1; //this variable showing the earned xp for particular level
            this.progressPercent = Math.round(
              (earnedXP / this.requiredXP) * 100
            );
          }
        }
      }
    },
    getUserKey(tokens) {
      if (tokens) {
        // 0 is for xp
        const keyObj = tokens.find((obj) => obj.key === 2);
        if (keyObj) {
          this.key = keyObj.value;
        }
      }
    },
    fetchUserTokens(id) {
      const payload = {
        userId: id,
      };
      this.$store
        .dispatch("users/getUserOrgTokens", payload)
        .then((res) => {
          if (res && res.data && res.data.length > 0) {
            res.data.forEach((res) => {
              res.tokens.forEach((token) => {
                const value = res.organizationConfigurationData.values.find(
                  (value) => value.key === token.tokenKey
                );
                if (value) {
                  token.organizationId = res.organizationId;
                  token.organizationData = res.organizationData;
                  token.label = value.label;
                }
              });
            });

            const organizedTokensArray = [];
            res.data.forEach((val) => {
              val.tokens.forEach((token) => {
                const index = organizedTokensArray.findIndex(
                  (item) => item.label === token.label
                );
                if (index === -1) {
                  if (token.tokenValueSum > 0) {
                    organizedTokensArray.push({
                      label: token.label,
                      tokens: [
                        {
                          userId: val.userId,
                          organizationId: val.organizationId,
                          organizationData: val.organizationData,
                          tokenKey: token.tokenKey,
                          tokenValueSum: token.tokenValueSum,
                        },
                      ],
                    });
                  }
                } else {
                  if (token.tokenValueSum > 0) {
                    organizedTokensArray[index].tokens.push({
                      userId: val.userId,
                      organizationId: val.organizationId,
                      organizationData: val.organizationData,
                      tokenKey: token.tokenKey,
                      tokenValueSum: token.tokenValueSum,
                    });
                  }
                }
              });
            });

            this.$store.commit("users/SET_USER_TOKENS", organizedTokensArray);
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    randomFeedImage(e) {
      let i = 15; // i = number of given random images
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[
        Math.floor(Math.random() * i),
      ]}.png`));
    },
    async connectMetaMask() {
      try {
        let metaMaskWalletAddress = await connectMetaMaskWallet();
        this.connectWalletPopup = false;
        console.log(metaMaskWalletAddress,this.formatWalletAddress(metaMaskWalletAddress));
      } catch (error) {
        console.error("Failed to connect MetaMask:", error);
      }
    },
    formatWalletAddress(address) {
      let firstFour = address.substring(0, 4);
      let lastFour = address.substring(address.length - 4);
      return `${firstFour}....${lastFour}`;
    },
  },
};
</script>

<style lang="scss" scoped>
$text-primary: #3c3c3c !important;
$text-secondary: #9b9b9b !important;
$bg-primary: #ededed !important;
$bg-secondary: #25cc9a !important;

.wallet {
  .user {
    &__picture {
      .__img {
        padding: 4px;
        width: 6em;
        height: 6em;
        border: 3px solid #cf42fa;
        border-radius: 50%;
      }

      .__level {
        font-size: 0.625rem;
        padding: 0.3rem 1.125rem;
        width: fit-content;
        background: linear-gradient(
          180deg,
          #c639f8 0%,
          #8213ff 52.6%,
          #a040e7 100%
        );
        color: white;
        position: absolute;
        top: 7.7em;
        border: 3px solid white;
        border-radius: 5em;
      }
    }

    &__info {
      .xp {
        top: 6px;
        right: -5px;
      }

      &--name {
        color: $text-primary;
      }

      &--title {
        color: $text-secondary;
      }
    }
  }

  // .balance {
  //   &__item {
  //     border-radius: 0.375rem;
  //     border: 1px solid #e8ebed;

  //     &__img {
  //       border-right: 1px solid #e8ebed;
  //     }
  //   }
  // }
}

// transactions
.table-header {
  background-color: #f2f4f7;
}

.txn-tip-market {
  background-color: #7a5af8;
}

.txn-tip-core {
  background-color: #fb6514;
}

.txn-tip {
  display: block;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}

.txn-type {
  text-transform: capitalize;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
  background-color: #ebe9fe;
  border-radius: 16px;
  max-width: fit-content;
}

.txn-type-market {
  background-color: #ebe9fe;
}

.txn-type-core {
  background-color: #ffead5;
}

.txn-not-confirmed {
  padding: 2px;
  display: block;
  border-radius: 50%;
  background-color: #fbb603;
  height: 10px;
  width: 10px;
}

.txn-success {
  padding: 2px;
  display: block;
  border-radius: 50%;
  background-color: #12b76a;
  height: 10px;
  width: 10px;
}

.txn-failed {
  padding: 2px;
  display: block;
  border-radius: 50%;
  background-color: red;
  height: 10px;
  width: 10px;
}

.transform-avatar {
  transform: translateX(-73%) translateY(-159%);
}

.details-btn {
  color: #bb9436;
}

::v-deep .vs-table--thead {
  z-index: -10 !important;
}

// progress bar
.progress {
  -webkit-appearance: none;
  appearance: none;
  border: none;
  border-radius: 10px;
  height: 11px;
  background-color: $bg-primary;
  place-self: center;
  text-align: left;
}

/* For Chrome or Safari */
progress::-webkit-progress-bar {
  background-color: $bg-primary;
  border-radius: 10px;
}

progress::-webkit-progress-value {
  background: linear-gradient(180deg, #c7f864 0%, #00db00 52.08%, #16f145 100%);
  border-radius: 10px;
}

/* For Firefox */
progress::-moz-progress-bar {
  background: linear-gradient(180deg, #c7f864 0%, #00db00 52.08%, #16f145 100%);
  border-radius: 10px;
}
</style>

<style scoped>
.con-vs-popup >>> .vs-popup {
  width: 400px;
}
</style>
